import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { memo, useId } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../Buttons/Button';
import DeleteIcon from '../../images/remove';
import SimpleModal, { HeaderIcon, InnerContent, ModalFooter, ModalHeader, ModalTitle } from '../SimpleModal';
import messages from './messages';
import useStyles from './styles';

const MODAL_MAX_WIDTH = 512;

export const ConfirmationModal = ({
  actionButtonText,
  cancelButtonText,
  handleClose,
  handleSubmit,
  modalContentText,
  ModalHeaderIcon,
  ModalHeaderIconBgColor,
  modalTitle,
  isSubmitting,
  hideCancelButton,
  hideHeaderIcon,
  negative,
  handleCancel,
  stackedButtons,
}) => {
  const classes = useStyles();
  const titleId = `confirmation-modal-title-${useId()}`;
  const cancelButton = (
    <Button
      autoWidth
      className={classes.cancelButton}
      onClick={handleCancel ?? handleClose}
      size="small"
      type="secondary"
    >
      {cancelButtonText}
    </Button>
  );

  return (
    <SimpleModal ariaLabelledBy={titleId} fullScreenOnMobile={false} maxWidth={MODAL_MAX_WIDTH} onClose={handleClose}>
      <ModalHeader onClose={handleClose}>
        {!hideHeaderIcon && (
          <HeaderIcon color={ModalHeaderIconBgColor || (negative ? 'red' : 'blue')} Icon={ModalHeaderIcon} />
        )}
        <ModalTitle id={titleId}>{modalTitle}</ModalTitle>
      </ModalHeader>
      <InnerContent>
        <Typography color="textPrimary">{modalContentText}</Typography>
      </InnerContent>
      <ModalFooter>
        <div className={stackedButtons && classes.stackedButtons}>
          {!hideCancelButton && cancelButton}
          <Button
            className={classes.ctaButton}
            disabled={isSubmitting}
            isLoading={isSubmitting}
            negative={negative}
            onClick={handleSubmit}
            size="small"
            type="primary"
          >
            {actionButtonText}
          </Button>
        </div>
      </ModalFooter>
    </SimpleModal>
  );
};

ConfirmationModal.propTypes = {
  ModalHeaderIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  ModalHeaderIconBgColor: PropTypes.string,
  actionButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.node,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hideCancelButton: PropTypes.bool,
  hideHeaderIcon: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  modalContentText: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  negative: PropTypes.bool,
  stackedButtons: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  ModalHeaderIcon: DeleteIcon,
  cancelButtonText: <FormattedMessage {...messages.cancel} />,
  hideCancelButton: false,
};

export default memo(ConfirmationModal);
